// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XFWi","colMin":"styles_colMin__1yimC"};